/**
 * RoomCard — expandable card with orange badge + sessions list (CR-0015).
 *
 * Default expand state: first room expanded, rest collapsed (U-I-05).
 */
import { useState } from "react";
import { ChevronUp, ChevronDown } from "lucide-react";
import SessionRow from "@/components/report/SessionRow";

export default function RoomCard({ room, defaultExpanded }) {
  const [open, setOpen] = useState(!!defaultExpanded);
  return (
    <div
      data-testid={`room-card-${room.code}`}
      className="mx-4 mt-3 bg-white rounded-md shadow-sm border"
      style={{ borderColor: "#E5E7EB" }}
    >
      <button
        data-testid={`room-card-toggle-${room.code}`}
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-4 py-3 text-left"
      >
        <div className="flex items-center gap-3">
          <div
            data-testid={`room-badge-${room.code}`}
            className="rounded-md px-3 py-1.5 font-bold text-white text-sm"
            style={{ backgroundColor: "#F97316" }}
          >
            {room.code}
          </div>
          <div>
            <div className="text-base font-semibold" style={{ color: "#111827" }}>
              Room {room.code}
            </div>
            <div className="text-xs" style={{ color: "#6B7280" }}>
              {room.n} {room.n === 1 ? "waiting session" : "waiting sessions"}
            </div>
          </div>
        </div>
        {open ? (
          <ChevronUp size={20} style={{ color: "#6B7280" }} />
        ) : (
          <ChevronDown size={20} style={{ color: "#6B7280" }} />
        )}
      </button>
      {open && (
        <div data-testid={`room-sessions-${room.code}`} className="px-4 pb-4 border-t" style={{ borderColor: "#F3F4F6" }}>
          <div className="text-sm font-bold mt-3 mb-1" style={{ color: "#111827" }}>
            Individual Sessions:
          </div>
          {room.sessions.map((s) => (
            <SessionRow key={s.n} session={s} />
          ))}
        </div>
      )}
    </div>
  );
}
